<ul>
    <li>Premier chiffre clé : {{ firstNumber() ? firstNumber() : 'non renseigné' }}</li>
    <li>Deuxième chiffre clé : {{ secondNumber() ? secondNumber() : 'non renseigné' }}</li>
    <li>Troisième chiffre clé : {{ thirdNumber() ? thirdNumber() : 'non renseigné' }}</li>
</ul>
